export default (state = {}, action) => {
    let { type, payload } = action
    switch (type) {
        case 'WEATHER_UPDATE_ACTION':
            return payload
        case 'WEATHER_ACTION_REMOVE':
            return null
        default:
            return state
    }
}
